interface LiveResourceBadgeProps {
  count: number;
}

export default function LiveResourceBadge({ count }: LiveResourceBadgeProps) {
  if (count <= 0) return null;

  return (
    <span className="absolute -top-2.5 -right-3.5 min-w-4 px-0.5 flex items-center justify-center bg-red-500 text-white text-xs rounded-full">
      {count > 99 ? '99+' : count}
    </span>
  );
}
